import { Button, Collapse, Fade } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../../Config/axios";
import { API_URLS } from "../../Config/API_URLS";
import SelectAddress from "../../Components/Checkout/SelectAddress";
import { useSnackbar } from "notistack";
import { useQueryClient } from "react-query";

export default function Monthly() {
  const { id, variant_id } = useParams();
  const navigate = useNavigate();
  const [value1, setValue1] = useState("");
  const [value, setValue] = useState("");
  const [searches, setSearches] = useState(true);
  const [date, setDate] = useState("");
  const [count, setCount] = useState([]);
  const currentDate = new Date();
  const futureDate = new Date(currentDate);
  futureDate.setMonth(currentDate.getMonth() + 1);
  const formattedfutureDate = futureDate.toISOString().split("T")[0];
  const formattedcurrentDate = currentDate.toISOString().split("T")[0];
  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }
  function convert1(str) {
    var date1 = new Date(str),
      mnth = ("0" + (date1.getMonth() + 1)).slice(-2),
      day = ("0" + date1.getDate()).slice(-2);
    return [date1.getFullYear(), mnth, day].join("-");
  }
  const day1 = convert1(date).slice(8);

  const handleDate = (date, quantity) => {
    setCount([...count, { day_of_month: date, quantity: quantity }]);
  };
  const handleAddition = (date) => {
    const quantity = [...count];
    const index = count?.findIndex(
      (day_of_month) => day_of_month.day_of_month === date
    );
    quantity[index].quantity++;
    setCount(quantity);
  };
  const handleSubstration = (date) => {
    const quantity = [...count];
    const index = count?.findIndex(
      (day_of_month) => day_of_month.day_of_month === date
    );
    quantity[index].quantity--;
    setCount(quantity);
  };

  useEffect(() => {
    date !== "" && handleDate(day1, 0);
  }, [day1]);

  // console.log(convert1(date).slice(8));
  const GetSubscriptionDaly = () => {
    // const reqbody = new FormData();
    // reqbody.append("subscription_plan_id", id);
    // reqbody.append("product_variants_id", 1);
    // reqbody.append("start_date", convert(value1));
    // reqbody.append("select_quantity", count);

    const reqbody = {
      subscription_plan_id: id,
      product_variants_id: variant_id,
      monthly_subscription_details: {
        start_date: formattedcurrentDate,
        days: count,
      },
    };
    axiosInstance
      .post(API_URLS.monthlySubscription, reqbody)
      .then((response) => {
        alert(response?.data?.message);
        response.data.response_code === 200 && addToCart(variant_id);
        navigate("/subscription");
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const handleLogin = (event) => {
    event.stopPropagation();
  };
  const { enqueueSnackbar } = useSnackbar();

  const client = useQueryClient();
  const addToCart = (variantId) => {
    const reqBody = new FormData();
    reqBody.append("product_id", variantId);
    reqBody.append("add_quantity", 1);
    axiosInstance
      .post(API_URLS.addToCart, reqBody)
      .then((response) => {
        client.refetchQueries(["myCartList"]);
        enqueueSnackbar(response.data.status);
      })
      .catch((error) => {
        enqueueSnackbar("Something went wrong..!", { variant: "error" });
      });
  };
  console.log(variant_id);
  return (
    <div className=" hm1 h-[500px] py-5 text-center text-white">
      <p className="text-4xl py-10">
        Monthly Plan In Months to Months So Get Your Plan{" "}
      </p>
      <div className="flex gap-5 justify-center">
        <div className="flex flex-col gap-10">
          <p className="text-2xl">StartDate:</p>
          <p className="text-2xl">EndDate:</p>
        </div>
        <div className="flex flex-col gap-10">
          <p className="text-2xl">{formattedcurrentDate}</p>

          <p className="text-2xl">{formattedfutureDate}</p>

          <p className="text-2xl">{date?.actual_price}</p>
        </div>
      </div>

      <div className="flex justify-center">
        <Button
          className="!p-3 hm2 !my-5 "
          onClick={GetSubscriptionDaly}
          variant="contained"
        >
          Confirm
        </Button>
      </div>
    </div>
  );
}
